// Timeseek - Quick Cart Modal
(function(){
  const modal = document.getElementById('quick-cart-modal');
  if (!modal) return;

  const closeEls = modal.querySelectorAll('[data-qc-close]');
  const form = modal.querySelector('#qc-form');
  const addBtn = modal.querySelector('#qc-add');
  const variantInput = modal.querySelector('#qc-variant-id');
  const priceEl = modal.querySelector('#qc-price');
  let lastActive = null;

  function openModal() {
    lastActive = document.activeElement;
    modal.setAttribute('aria-hidden','false');
    modal.querySelector('.qc-dialog').focus();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
    if (lastActive) lastActive.focus();
  }
  closeEls.forEach(el => el.addEventListener('click', closeModal));
  modal.addEventListener('click', (e)=>{ if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') closeModal(); });

  // 1) Variant変更に追従（Dawnは variant:change を発火）
  document.addEventListener('variant:change', (evt)=>{
    const { variant } = evt.detail;
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;

    // 価格エリアを製品ページの価格からコピー（最も簡単・確実）
    const livePrice = document.querySelector('[id^="price-"] .price');
    if (livePrice && priceEl) priceEl.innerHTML = livePrice.outerHTML;
  }, { passive: true });

  // 2) 「Add to Cart」送信
  if (form) {
    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      if (!variantInput.value) return;

      addBtn.disabled = true;
      addBtn.dataset.loading = 'true';

      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd });
        if (!res.ok) throw new Error('Add to cart failed');
        // 成功: ボタン状態を更新（or カートドロワーを開く）
        addBtn.textContent = addBtn.dataset.addedLabel || '追加しました';
        addBtn.classList.add('is-added');

        // 可能なら Dawn の cart drawer を開く（テーマにより存在しないことも）
        const cartDrawerToggle = document.querySelector('[data-cart-drawer-toggle], .header__icon--cart');
        if (cartDrawerToggle) cartDrawerToggle.click();

        // 2秒後に閉じる（好みに応じて）
        setTimeout(closeModal, 1500);
        document.dispatchEvent(new CustomEvent('cart:refresh')); // 他ウィジェット用
      } catch (err) {
        console.error(err);
        addBtn.textContent = 'エラー。もう一度';
      } finally {
        addBtn.disabled = false;
        addBtn.dataset.loading = '';
      }
    });
  }

  // 3) トリガー（固定バーや既存ボタンから起動）
  function wireTriggers(){
    // data-qc-open を持つ要素でモーダル起動
    document.querySelectorAll('[data-qc-open]').forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        openModal();
      });
    });

    // PDPの「購入ボタンを押すとまずモーダル」派なら↓を有効化
    // const buyBtn = document.querySelector('product-form [type="submit"].product-form__submit');
    // if (buyBtn) {
    //   buyBtn.addEventListener('click', (e)=>{ e.preventDefault(); openModal(); });
    // }
  }
  wireTriggers();

})();
